import { Link } from "react-router";
import { BellOutlined } from "@ant-design/icons";
import { useCurrentUser, useNotifications } from "@/data/hooks";
import { RoutePaths } from "@/views/routes";
import { PropsWithChildren, ReactNode } from "react";
import { Badge } from "antd";

interface WrapProps {
  wrap: boolean;
  children: ReactNode;
  wrapper: (p: PropsWithChildren<object>) => ReactNode;
}
function Wrap({ wrap, children, wrapper }: WrapProps): ReactNode {
  return <>{wrap ? wrapper({ children }) : children}</>;
}

export default function NotificationBell() {
  const { user, authStateLoaded } = useCurrentUser();
  const { isLoaded, notifications } = useNotifications();
  if (!user || !authStateLoaded) {
    return <></>;
  }

  return (
    <>
      <Link to={RoutePaths.notifications} viewTransition>
        <Wrap
          wrap={isLoaded && (notifications?.length || 0) > 0}
          wrapper={({ children }) => (
            <Badge size="small" count={notifications?.length || 0}>
              {children}
            </Badge>
          )}
        >
          <BellOutlined />
        </Wrap>
      </Link>
    </>
  );
}
